import { render, staticRenderFns } from "./TotalInformationCard.vue?vue&type=template&id=13088fd3&scoped=true&"
import script from "./TotalInformationCard.vue?vue&type=script&lang=ts&"
export * from "./TotalInformationCard.vue?vue&type=script&lang=ts&"
import style0 from "./TotalInformationCard.vue?vue&type=style&index=0&id=13088fd3&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13088fd3",
  null
  
)

export default component.exports